import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Box, Typography, Button } from '@mui/material'
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material'
import TemplatePreview from '../components/integrations/TemplatePreview'
import integrationService from '../services/integrationService'

const TemplatePreviewPage: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [template, setTemplate] = React.useState<any>(null)
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    if (id) {
      loadTemplate()
    }
  }, [id])

  const loadTemplate = async () => {
    try {
      const data = await integrationService.getTemplate(id!)
      setTemplate(data)
    } catch (error) {
      console.error('Failed to load template:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    navigate('/admin/integrations/templates')
  }

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Loading template...</Typography>
      </Box>
    )
  }

  if (!template) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Template not found</Typography>
        <Button startIcon={<ArrowBackIcon />} onClick={handleClose} sx={{ mt: 2 }}>
          Back to Templates
        </Button>
      </Box>
    )
  }

  return (
    <Box sx={{ p: 3 }}>
      <TemplatePreview template={template} onClose={handleClose} />
    </Box>
  )
}

export default TemplatePreviewPage
